export const setEquality = (a: Set<unknown>, b: Set<unknown>): boolean =>
  a.size === b.size && Array.from(a).every((value) => b.has(value))
